import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useEffect, useRef, useState, useMemo } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery'
import { Grid, Stack, Typography } from '@mui/material';
import { map } from 'mathjs';
import config from '../../config.json';

const waldVitalitaetLegend = require("../../ressources/legends/legendWaldVitalitaet.png")
const waldartenLegend = require("../../ressources/legends/legendWaldarten.png")
const baumhoeheLegend = require("../../ressources/legends/legendBaumhoehe.png")
const schadflaechen = require("../../ressources/legends/schadflaechen.png")
const biomasse = require("../../ressources/legends/biomasse.png")
const waldvitalitaet = require("../../ressources/legends/legendWaldVitalitaet.png")
const wasserbilanz = require("../../ressources/legends/wasserbilanz.png")


interface LegendSimpleProps {
    layerSelection: any
}

export default function LegendMultipleSteps({ layerSelection }: LegendSimpleProps) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    // let legendImage;



    let legendImages: { [key: string]: string } = {};

    legendImages = {
        "WASSERDEFIZIT": wasserbilanz,
        "WALDVITALITAET": waldvitalitaet,
    }

    interface LegendInfo {
        scaleSteps: string[],
        unit: string,
        image: any,
        scaleStepsPosition: string[]
    }

    let legendInfo: LegendInfo = {
        scaleSteps: [],
        unit: "",
        image: null,
        scaleStepsPosition: []
    }


    function setLegendInfo(layerSelection: any) {
        // Get rescale factor dynamically from drone/satelliteRasterLayerInfo

        switch (layerSelection.layer2) {
            case "WALDVITALITAET":
                legendInfo.image = legendImages["WALDVITALITAET"]
                legendInfo.unit = ""
                legendInfo.scaleSteps = ["Kalamität/ Holzeinschlag","Vitalitäts- verschlechterung", "Keine Veränderung", "Vitalitäts- verbesserung"]
                legendInfo.scaleStepsPosition = ["flex-start","center", "center", "flex-end"]
                break;
            case "WASSERDEFIZIT":
                legendInfo.image = legendImages["WASSERDEFIZIT"]
                legendInfo.unit = ""
                legendInfo.scaleSteps = ["Kronenverlichtung", "Trockenstress", "Keine Veränderung", "Verbesserte Wasserbilanz"]
                legendInfo.scaleStepsPosition = ["flex-start", "center", "center", "flex-end"]
                break;
        }



    }

    setLegendInfo(layerSelection)



    // create a typography mui component with 5px font size
    const TypographyLegendMultiple = styled(Typography)({
        maxWidth:'120px',
        fontSize: '12px',
        // wordWrap: 'normal',
    });
    //Move typography component to the left inside Grid item
    // const GridItem = styled(Grid)({
    //     paddingLeft: '0px',
    // });


    const legendContent = (
        <>
            <Stack alignItems="center" >
                <Box
                    component="img"
                    sx={{
                        // m: 1,
                        // width: "70vw",
                        p: 1,
                        pb: 0.3,
                        width: "95%",
                    }}
                    src={legendInfo.image}
                />
            </Stack>
            <Paper elevation={0} >

                <Grid container direction="row" justifyContent="space-between" paddingLeft={1} paddingRight={1} pt={0} >

                    {
                        legendInfo.scaleSteps.map((step, index) => (
                            <Grid item xs={12/legendInfo.scaleSteps.length} key={index} pt={0} >
                                <Grid container justifyContent={legendInfo.scaleStepsPosition[index]}>
                                    <TypographyLegendMultiple variant="body2" align="center" color="text.secondary">
                                        {step}
                                    </TypographyLegendMultiple>
                                </Grid>

                            </Grid>
                        ))
                    }
                </Grid>

            </Paper>
        </>

    )



    return (
        <>
            {!mobile && legendInfo.image &&
                <LegendDesktop
                    layerSelection={layerSelection}>
                    {legendContent}
                </LegendDesktop>
            }

        </>


    )

}



function LegendDesktop(props: any) {
    const widthBleeding = 600;
    const marginLeft = config.sizing.drawerWidthDesktop / 2 + (-widthBleeding / 2);

    return (
        <Box
            sx={{
                position: 'absolute',
                display: 'flex',
                zIndex: 1000,
                mt: 2,
                left: "50%",
                width: `${widthBleeding}px`,
                ml: `${marginLeft}px`,


            }}
        >
            <Paper elevation={3} >
                {props.children}
            </Paper>
        </Box >
    );
}



function LegendMobile(props: any) {
    return (
        <Box
            sx={{
                position: 'relative',
                zIndex: 1000,
                // bottom: 100,
            }}
        >
            <Paper elevation={3} square={true}>
                {props.children}
            </Paper>
        </Box >
    );
}